const default_pubmatic_config = {
    active: true,
    'all': {
        publisherId: '156612',
    },
    'efe_hp_728': {
        adSlot: 'EFE_homepage_top_728'
    },
    'efe_topics_160': {
        adSlot: 'EFE_topics_left'
    },
    'efe_topics_bottom_728': {
        adSlot: 'EFE_topics_bottom_728'
    },
    'efe_topics_mid_728_1': {
        adSlot: 'EFE_topics_mid_728_1'
    },
    'efe_topics_mid_728_2': {
        adSlot: 'EFE_topics_mid_728_2'
    },
    'efe_topics_mid_728_3': {
        adSlot: 'EFE_topics_mid_728_3'
    },
    'efe_300_mid': {
        adSlot: 'EFE_mid_336'
    }
};
export const pubmatic_config = default_pubmatic_config
